import React, { useEffect } from 'react'
import './Add_wallet.css'
import Breadcrumb_Comp from '../common/common_components/breadcrumb_comp/Breadcrumb_Comp'
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import Add_money from './add-money/Add_money';
import Wallet_transaction from './wallet-transaction/Wallet_transaction';
import { useDispatch, useSelector } from 'react-redux';
import { getAllWalletHistory } from '../../features/wallet/walletSlice';
import Withdrawl_Request_Form from './withdrawl_request_form/Withdrawl_Request_Form';


const Add_wallet = () => {
    const breadcrumbs = [
        { label: "PROFILE", link: "/profile", active: false },
        { label: "WALLET", link: "", active: true, }
    ];

    const dispatch = useDispatch();
    const walletHistory = useSelector((state) => state.wallet.allWalletHistory);

    useEffect(() => {
        dispatch(getAllWalletHistory());
    }, [dispatch]);


    console.log({ walletHistory });
    return (
        <>
            <section className='Add_wallet_sec'>
                <div className='container'>
                    <Breadcrumb_Comp data={breadcrumbs} />

                    <div className='row'>
                        <div className='col-lg-12 col-md-8 mx-auto'>
                            <div className='add_wallet_tab_div' >
                                <Tab.Container id="left-tabs-example" defaultActiveKey="addmoney">
                                    <Nav variant="pills" className="d-flex">
                                        <Nav.Item >
                                            <Nav.Link eventKey="addmoney">Add Money</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="wallettrans">Wallet Transactions</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="withdrawl_request">Withdrawal Request</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                    <Tab.Content>
                                        <Tab.Pane eventKey="addmoney">
                                            <Add_money Wallet={walletHistory?.user_wallet} />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="wallettrans">
                                            <Wallet_transaction />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="withdrawl_request">
                                            <Withdrawl_Request_Form />
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Tab.Container>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </>
    )
}

export default Add_wallet